// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import blobalVariable from './utils/global_variable'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import httpRequest from '@/server/http-api'
import filter from '@/filter/filter'
// import permission from '@/utils/permission'

import '@/utils/permission'
import "babel-polyfill";
import Swiper from 'swiper'; 
import "swiper/css/swiper.min.css";
import moment from 'moment';

window.jQuery = $;
window.$ = $;

import 'element-ui/lib/theme-chalk/index.css'
import '@/../static/css/reset.css'        /*引入公共样式-重置文件*/
import '@/../static/css/show_ui.css'        /*引入公共样式-重置文件*/
import '@/../static/css/animate.css'        /*引入公共样式-动画*/
// import 'swiper/dist/css/swiper.min.css'  /*引入swiper样式-重置文件*/
import '@/../static/css/froala_style.min.css'

import videoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(videoPlayer)
Vue.filter('dateformat', function(dataStr, pattern = 'YYYY.MM.DD') {

  return moment(dataStr).format(pattern)
  
  })
  // <span>发表时间：{{ item.date | dateformat('YYYY.MM.DD')}}</span>

Vue.config.productionTip = false
Vue.prototype.$store = store
Vue.prototype.$client = httpRequest
Vue.prototype.GLOBAL_VARIABLE = blobalVariable

Vue.use(ElementUI)
Vue.use(Vuex)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js